import * as React from 'react';
import HighchartsContext from '../HighchartsContext'; // This is a HOC function.
// It takes a component...

export default function withHighcharts(Component, Highcharts) {
  // ...and returns another component...
  return function HighchartsWrappedComponent(props) {
    // ... and renders the wrapped component with the context theme!
    // Notice that we pass through any additional props as well
    return /*#__PURE__*/React.createElement(HighchartsProvider, {
      Highcharts: Highcharts
    }, /*#__PURE__*/React.createElement(Component, props));
  };
}
export var HighchartsProvider = function HighchartsProvider(_ref) {
  var Highcharts = _ref.Highcharts,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(HighchartsContext.Provider, {
    value: Highcharts
  }, children);
};